import { Avatar, Form } from 'antd';
import styled from 'styled-components';
import colorTheme from 'constants/color';
import Close from 'assets/Icons/close';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import Box from 'components/Box';
import Text from 'components/Text';
import Change from 'assets/Icons/change';
import ChangeServiceModal, { ChangeServiceModalRef } from '../ChangeServiceModal';
import { useRef, useState } from 'react';
import ModalChooseStaffFilter from 'widgets/Staff/DropDown/ModalChooseStaffFilter';
import { IStaffItemData } from 'services/shop/types/staff';
import { AddStaffSaleFormValues } from './AddStaffSaleModal';

type StaffRowProps = {
  name: number;
  remove?: () => void;
  filterStaff?: (staffs: IStaffItemData[]) => IStaffItemData[];
};

const StaffRow = ({ name, remove, filterStaff }: StaffRowProps) => {
  const useChangeServiceModalRef = useRef<ChangeServiceModalRef>(null);
  const [chooseStaffVisible, setChooseStaffVisible] = useState(false);
  const form = Form.useFormInstance<AddStaffSaleFormValues>();
  const rowData = Form.useWatch(['staffs', name], form);

  const handleChangeStaff = (staff: IStaffItemData) => {
    form.setFieldValue(['staffs', name, 'staffId'], staff.id);
    form.setFieldValue(['staffs', name, 'staffName'], staff.firstName);
    form.setFieldValue(['staffs', name, 'avatar'], staff.urlImage);
    setChooseStaffVisible(false);
  };

  return (
    <>
      <tr>
        <td className='no-style'>
          <div className='container-box'>
            <ServicesBox>
              <button
                type='button'
                onClick={() =>
                  useChangeServiceModalRef.current?.open((_, serviceObject) => {
                    form.setFieldValue(['staffs', name, 'service'], serviceObject?.serviceName || '');
                    form.setFieldValue(['staffs', name, 'serviceId'], serviceObject?.id || '');
                  })
                }
                className='service-select-btn'
              >
                <Form.Item
                  noStyle
                  name={[name, 'service']}
                  rules={[{ required: true, message: 'Please select at least one service' }]}
                >
                  <input className='service-name' placeholder='Select service' readOnly />
                </Form.Item>
                <div className='btn-change-service'>
                  <Change fill='#FFFFFF' width={32} height={32} />
                </div>
              </button>
            </ServicesBox>
          </div>
        </td>
        <td className='staff-info no-style'>
          <div className='container-box staff-col'>
            <button type='button' onClick={() => setChooseStaffVisible(true)} style={{ width: '100%' }}>
              <Box width='100%' display='flex' justifyContent='space-between' alignItems='center'>
                <Box display='flex' gap='2' alignItems='center'>
                  <Avatar src={rowData?.avatar || 'fail'} size={50}>
                    {rowData?.staffName?.[0] || 'A'}
                  </Avatar>
                  <Text variant='H5' style={{ fontWeight: 500, fontFamily: 'Poppins' }}>
                    {rowData?.staffName || 'Select Staff'}
                  </Text>
                </Box>
                <Change fill={colorTheme.v2_blue_3} width={40} height={40} />
              </Box>
            </button>
          </div>
        </td>
        <td>
          <div className='container-box with-input'>
            <Form.Item
              noStyle
              name={[name, 'amount']}
              rules={[
                {
                  required: true,
                  message: 'Please input amount',
                },
                {
                  validator: (_, value) => {
                    if (value > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Amount must be greater than 0'));
                  },
                },
              ]}
            >
              <CurrencyInputPrecision />
            </Form.Item>
          </div>
        </td>
        <td className='action'>
          <div className='container-box'>
            <button type='button' className='btn-delete' onClick={remove}>
              <Close fill={colorTheme.v2_primary_bg_6} />
            </button>
          </div>
        </td>
      </tr>
      <ChangeServiceModal ref={useChangeServiceModalRef} />
      <ModalChooseStaffFilter
        filter={filterStaff}
        visible={chooseStaffVisible}
        onChooseStaff={handleChangeStaff}
        onClose={() => setChooseStaffVisible(false)}
      />
    </>
  );
};

export default StaffRow;

const ServicesBox = styled.div`
  display: flex;
  border: 1px solid ${colorTheme.v2_border_3};
  width: 100%;
  height: 54px;
  padding-left: 16px;
  border-radius: 4px;

  .service-select-btn {
    width: 100%;
    height: 100%;
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .btn-change-service {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    margin-left: 16px;
    height: 100%;
    background: ${colorTheme.v2_blue_3};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .service-name {
    width: 100%;
    height: 90%;
    font-size: 1.5rem;
    font-weight: 500;
    font-family: 'Poppins';
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    cursor: pointer;
    pointer-events: none;
    &:focus {
      outline: none;
    }
  }
`;
